const ITEMS = ["38 Years Experience", "Independent Advice", "Technical Review", "Practical Site Support"];

export default function Marquee() {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            className="overflow-hidden border-y border-slate-800 bg-navy py-4"
            aria-label="38 Years Experience, Independent Advice, Technical Review, Practical Site Support"
            data-testid="trust-marquee"
        >
            <div className="marquee-track flex w-max items-center gap-10">
                {[...row, ...row].map((item, i) => (
                    <span key={i} className="flex items-center gap-10 whitespace-nowrap">
                        <span className="font-mono text-xs uppercase tracking-[0.25em] text-slate-300">{item}</span>
                        <span className="h-1.5 w-1.5 rotate-45 bg-amber" aria-hidden="true" />
                    </span>
                ))}
            </div>
        </div>
    );
}
